.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingSm);
}

.multiToggleContainer {
  display: flex;

  & > .button:focus-visible {
    outline: 0;
    border: 1px solid var(--paletteBlue0);
    box-shadow: inset 0 0 0 1px var(--paletteBlue0);
  }

  &.fitHeightToContent > .button {
    height: auto;
  }
}

.multiToggleContainer:not(.rounded) {
  &.fluid > .button {
    width: unset;
    padding: var(--spacingSm) var(--spacingLg);
  }

  & > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > button:first-child {
    border-radius: var(--radiusMd) 0 0 var(--radiusMd);
  }

  & > button:last-child {
    border-left: 0;
    border-radius: 0 var(--radiusMd) var(--radiusMd) 0;
  }

  & > button:not(:first-child, :last-child) {
    border-left: 0;
  }
}

.multiToggleContainer.rounded {
  flex-direction: row;
  gap: var(--spacingMd);

  & > button {
    line-height: 0;
    border-radius: 18px;
    height: 36px;
    width: 36px;
    padding: var(--spacingMd);
  }
}

.button {
  padding: var(--spacingMd);
  border: 1px solid var(--paletteNeutral0);
  background: var(--paletteWhite0);
  color: var(--paletteBlue0);

  .buttonLabel {
    line-height: unset;

    svg {
      display: block;
    }
  }

  &:hover {
    background: var(--paletteTrans0);
    cursor: pointer;
  }

  &.disabled {
    .buttonLabel {
      opacity: 0.5;
    }
  }
}

.selected {
  background: var(--paletteBlue1);
  border-color: var(--paletteBlue1);
  color: var(--paletteWhite0);

  svg {
    fill: var(--paletteWhite0);
  }

  &:hover {
    background: var(--paletteBlue1);
    border-color: var(--paletteBlue1);
  }
}

.errorContainer {
  > button {
    border-top: 1px solid var(--paletteRed1);
    border-bottom: 1px solid var(--paletteRed1);
  }

  > button:first-child {
    border-left: 1px solid var(--paletteRed1);
  }

  > button:last-child {
    border-right: 1px solid var(--paletteRed1);
  }
}
